import { Flex, Icon, Text } from '@inflearn/ds-react-next';
import { faStar } from '@inflearn/pro-solid-svg-icons';

export function RatingItem({ content }: { content: string }) {
  return (
    <Flex align="center" gap={2}>
      <Icon icon={faStar} size="sm" color="yellow.6" />
      <Text fz={16} fw={600} lh="1.7" c="gray.9">
        {content}
      </Text>
    </Flex>
  );
}
